import { Skeleton as MuiSkeleton } from '@mui/material';
import type { SkeletonProps as MuiSkeletonProps } from '@mui/material/Skeleton';

export type SkeletonProps = MuiSkeletonProps;

export const Skeleton = ({ ...rest }: SkeletonProps): JSX.Element => <MuiSkeleton {...rest} />;
